import { render, staticRenderFns } from "./ProductCartControl.vue?vue&type=template&id=06c631d0&scoped=true&"
import script from "./ProductCartControl.vue?vue&type=script&lang=js&"
export * from "./ProductCartControl.vue?vue&type=script&lang=js&"
import style0 from "./ProductCartControl.vue?vue&type=style&index=0&id=06c631d0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06c631d0",
  null
  
)

export default component.exports